import {createAction, props} from '@ngrx/store';
import {EkranDecyzjaRoszczeniaActionType} from './ekran-roszczenie.action-types';
import {Samoobsluga} from '../../../../shared/services/samoobsluga/types/samoobsluga';
import {ParametryKwotyDocelowej} from '../../../../shared/services/samoobsluga/types/ParametryKwotyDocelowej.interface';

export const kliknietoDalejRoszczenie = createAction(
  EkranDecyzjaRoszczeniaActionType.KLIKNIETO_DALEJ_ROSZCZENIE,
  props<{ correlationId: string, przedmiotyZRoszczeniami: { idPrzedmiotu: number, kwotaRoszczenia: number }[] }>()
);

export const kliknietoDalejRoszczenieSuccess = createAction(
  EkranDecyzjaRoszczeniaActionType.KLIKNIETO_DALEJ_ROSZCZENIE_SUCCESS,
  props<ParametryKwotyDocelowej>()
)

export const kliknietoWroc = createAction(
  EkranDecyzjaRoszczeniaActionType.KLIKNIETO_WROC, props<{ correlationId: string }>()
);

export const kliknietoWrocSuccess = createAction(
  EkranDecyzjaRoszczeniaActionType.KLIKNIETO_WROC_SUCCESS, props<Samoobsluga>()
);
